<template>
    <!-- 下载 -->
    <div class="">
      <v-dialog
      name="basic-t"
      v-model="isShow"
      :title="dialogTitle"
      :close-on-click-modal="closeOnClickModal1"
      :modal="true"
      :width="80"
      :height="30"
      @confirm="handleConfirm"
      @after-close="handleAfterClose"
      v-bind:confirmButtonText= "suredown"
      append-to-body
    >
    <v-form ref="form" :model="ruleForm" :rules="rules">
            <v-form-item  prop="change_log" class="newlag">
                <template slot="label" class="newlag-left">
                  <span class="required"></span>
                  <span>添加新语言</span>
                </template>
                <v-radio v-model="ruleForm.newlanguage" name="radio" :options="languageOptions"></v-radio>
            </v-form-item>
        </v-form>

    </v-dialog>
      </div>
</template>

  <script>
  export default {
    components: {},
    props:{
        showAddDialog:{
        type:Boolean,
        default: false
      },
    },
    data() {
      return {
        rules:{
           newlanguage:''
        },
        dialogTitle: "添加语言",
        closeOnClickModal1: false, //点击周围关闭弹窗
        suredown:"添加",
        isShow:false,

        ruleForm:{
          newlanguage:'',
        },
        languageOptions: [
          {
            label:'波兰',
            value:'pl'
          },{
            label:'巴西葡语',
            value:'pt-BR'
          },{
            label:'土耳其',
            value:'tr'
          },{
            label:'印度尼西亚',
            value:'id'
          },{
            label:'韩文',
            value:'ko'
          },{
            label:'意大利',
            value:'it'
          },{
            label:'西班牙语',
            value:'es'
          },
        ],
        addData:{}
      };
    },
    created() {

    },
    watch:{
      showAddDialog(newVal){
        this.isShow = newVal
      }
    },
    methods: {
      zhuan(){

      },
      handleConfirm() {
        for (let i=0; i < this.languageOptions.length;i++){
          if(this.languageOptions[i].value == this.ruleForm.newlanguage){
            this.addData = this.languageOptions[i]
          }
        }
        const valid = this.$refs.form.submitForm();
        if (valid === false) {
          return;
        }

        this.$emit("addNewLag",this.addData)
        this.ruleForm.newlanguage = ''
        this.$emit('update:showAddDialog',false)
        Object.assign(this.$data, this.$options.data())
      },
        handleAfterClose() {
          this.$emit('update:showAddDialog',false)
          Object.assign(this.$data, this.$options.data())
        },
    },
    beforeDestroy() {},
  };
  </script>

  <style lang="scss">
    .newlag {
        .v-form-item__label{
            margin-left: 80px;
        }

        .v-form-item__content{
            float: left;
            margin-left: 22px!important;
            width: 290px;
            word-break: break-all;

        }
    .v-radio__list>.v-radio__item:nth-child(1){
      margin-left: 26px;
    }
    .v-radio__list{
      margin-left: -26px;
    }
    }
  </style>
